import { styled } from 'styled-components';
import { Modal, Title } from '../../components';

const NSFWModal = ({ open, handleClose }) => {
  return (
    <Modal
      open={open}
      cancel='No, take me back'
      accept='Yes, I am 18+ years'
      theme='danger'
      handleCancel={() => handleClose(false)}
      handleAccept={() => {
        handleClose(true);
      }}
    >
      <Wrapper>
        <Title>Warning</Title>
        <p>
          The content you are trying to navigate to is adult content and should only be seen by
          those 18 years or older.
        </p>
        <p>Do you wish to continue?</p>
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
`;

export default NSFWModal;
